import React from 'react';
import { Transaction } from '../mocks/mockData';
import { clsx } from 'clsx';

interface ExpenseCardProps {
  transaction: Transaction;
  className?: string;
}

export function ExpenseCard({ transaction, className }: ExpenseCardProps) {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div className={clsx('bg-white dark:bg-gray-800 rounded-lg border dark:border-gray-700 p-4 shadow-sm', className)}>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="flex items-center space-x-3">
            <div className="w-3 h-3 rounded-full bg-blue-500"></div>
            <div>
              <p className="font-medium text-gray-900 dark:text-white">{transaction.description}</p>
              <div className="flex items-center space-x-2 text-sm text-gray-500 dark:text-gray-400">
                <span>{transaction.merchant}</span>
                <span>•</span>
                <span>{formatDate(transaction.date)}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="text-right">
          <p className="font-semibold text-gray-900 dark:text-white">{formatCurrency(transaction.amount)}</p>
          <p className="text-sm text-gray-500 dark:text-gray-400">{transaction.category}</p>
        </div>
      </div>
    </div>
  );
}